import ptBr from "../lang/ptBr";
import en from "../lang/en";
import es from "../lang/es";

const languages = {
    ptBr,
    en,
    es,
};

export function langFromLocale(locale) {
    const value = String(locale || "pt-BR").toLowerCase();
    if (value.startsWith("en")) {
        return "en";
    }
    if (value.startsWith("es")) {
        return "es";
    }
    return "ptBr";
}

export function translate(term, langKey, replaces) {
    let lang = languages[langKey] || languages.ptBr;
    if (!term) {
        return "";
    }
    const args = term.split("-");
    for (let i = 0; i < args.length; i++) {
        if (!lang || lang[args[i]] === undefined) {
            return term;
        }
        lang = lang[args[i]];
    }
    let text = lang;
    if (typeof text !== "string") {
        return term;
    }
    if (replaces) {
        Object.keys(replaces).forEach((key) => {
            text = String(text)
                .split("{" + key + "}")
                .join(replaces[key] == null ? "" : replaces[key]);
        });
    }
    return text;
}

export function applyPlaceLanguage(place, root) {
    const locale = (place && place.locale) || "pt-BR";
    const lang = langFromLocale(locale);
    if (root) {
        root.lang = lang;
        root.locale = locale;
    }
    if (typeof document !== "undefined") {
        document.documentElement.lang = locale;
    }
    return lang;
}

export const i18nMixin = {
    methods: {
        t: function (term, replaces) {
            return translate(term, this.$root.lang || "ptBr", replaces);
        },
    },
};

export default languages;
